// The narrated timeline is redrawn by morphing (PaperworkEvent and
// PaperworkProcess broadcasts with method: :morph). A morph sets every
// attribute back to the server's, which would close what a person opened
// while reading. Kept across a morph:
//   • `open` on a step list, a run line or a note (<details>) the person
//     opened or closed themselves; one they never touched still follows the
//     server, so a live turn's steps can fold when it ends;
//   • a value lens's panel `hidden` and its button's `aria-expanded`
//     (narrated_lens_controller), which the server always draws closed.
// Table fitting (table_density_controller) keeps its own classes the same way.

const PERSON_TOGGLED = "details.narrated-steps, details.run-line, details.narrated-note"
const toggled = new WeakSet()

export function attachMorphKeep(doc = document) {
  const win = doc.defaultView || window
  if (win.__morphKeepAttached) return
  win.__morphKeepAttached = true

  doc.addEventListener("click", (event) => {
    const summary = event.target?.closest?.("summary")
    const details = summary?.parentElement
    if (details?.matches?.(PERSON_TOGGLED) && details.querySelector(":scope > summary") === summary) toggled.add(details)
  }, true)

  doc.addEventListener("turbo:before-morph-attribute", (event) => {
    if (keepsAttribute(event.target, event.detail?.attributeName)) event.preventDefault()
  })
}

export function keepsAttribute(element, attributeName) {
  if (!element?.matches) return false
  if (attributeName === "open") return toggled.has(element)
  if (attributeName === "hidden") return element.matches("[data-narrated-lens-target~='panel']")
  if (attributeName === "aria-expanded") return element.matches("[data-action~='narrated-lens#toggle']")
  return false
}

export function markToggled(details) {
  toggled.add(details)
}
